import {
    ACTION_SET_EMOJI_ADMIN_WASM,
    ACTION_SET_EMOJI_TYPES_WASM,
    ACTION_SET_EMOJI_WASM,
    type EmojiActionTypes,
    type EmojiState,
} from '../types/emoji';

const DEFAULT: EmojiState = {
    wasm: null,
    adminWasm: null,
    types: null,
    emojis: [],
    userEmojis: [],
};

export function emoji(state: EmojiState = DEFAULT, action: EmojiActionTypes): EmojiState {
    switch (action.type) {
        case ACTION_SET_EMOJI_WASM:
            return { ...state, wasm: action.wasm };
        case ACTION_SET_EMOJI_ADMIN_WASM:
            return { ...state, adminWasm: action.wasm };
        case ACTION_SET_EMOJI_TYPES_WASM:
            return { ...state, types: action.wasm };
        default:
            return { ...state };
    }
}
